export default "__VITE_ASSET__749d15bb__"